import React from 'react';
import Image from 'next/image';
import mobiletabiosimg from "../../public/images/mobiletabiosimg.png";
import iossvg from "../../public/svg/ios.svg";
import andriodsvg from "../../public/svg/andriod.svg";
import { motion } from 'framer-motion';

const Andriodiosservice = () => {
  return (
    <div className='mobileios_overlay'>
      <div className='grid grid-cols-1 lg:grid-cols-12 2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 my-0 '>
        <div className='col-span-1 lg:col-span-6 flex flex-col justify-center -mt-14'>
          <motion.h2
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{
              delay: 0.2,
              y: {
                type: "spring",
                stiffness: 60
              },
              opacity: { duration: 1 },
              ease: "easeIn", duration: 1
            }}
            className=' text-[#41b8ea] pb-3 lg:text-3xl text-xl font-normal lg:text-right text-center'>Services</motion.h2>
          <motion.h4
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{
              delay: 0.4,
              y: {
                type: "spring",
                stiffness: 60
              },
              opacity: { duration: 1 },
              ease: "easeIn", duration: 1
            }}
            className='text-[#000] pb-2 lg:text-4xl font-extraboldl lg:text-right text-center'>Available on IOS & Android</motion.h4>
          <motion.p
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{
              delay: 0.6,
              y: {
                type: "spring",
                stiffness: 60
              },
              opacity: { duration: 1 },
              ease: "easeIn", duration: 1
            }}
            className='text-[#000] pb-16 text-[14px] lg:text-right text-center'>Systematic inefficiencies in operations can lead to a productivity drop of 20-30% on average. Our mobile application, accessible on both iOS and Android, facilitates quick decision-making, provides instant reports, strengthens partnerships, streamlines the supply chain, and more, ultimately boosting productivity.</motion.p>
          <motion.span
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{
              delay: 0.8,
              y: {
                type: "spring",
                stiffness: 60
              },
              opacity: { duration: 1 },
              ease: "easeIn", duration: 1
            }}
            className='flex text-right justify-end'>
            <button className='bg-[#FFDA32] text-[#1C2B38] rounded-[40px] py-3 px-8 flex button02' style={{ boxShadow: '0px 0px 15px #FFDA32' }}>
              <Image src={iossvg} alt='interview preps' />
              <span className='lg:pl-2'>Download For IOS</span>
            </button>
            <button className='bg-[#FFDA32] text-[#1C2B38] rounded-[40px] py-3 px-8 flex ml-5 button02' style={{ boxShadow: '0px 0px 15px #FFDA32' }}>
              <Image src={andriodsvg} alt='how to decline a job offer' />
              <span className='pl-2'>Download For Android</span>
            </button>
          </motion.span>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className='col-span-1 lg:col-span-6 '>
          <Image src={mobiletabiosimg} alt='how to reject a job offer' className='w-[500px] h-auto' />
        </motion.div>
      </div>
    </div>
  )
}

export default Andriodiosservice